import { render, staticRenderFns } from "./CommitmentDetails.vue?vue&type=template&id=7fab453d"
import script from "./CommitmentDetails.vue?vue&type=script&lang=js"
export * from "./CommitmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports